import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  tableWrapper: {
    overflowX: "auto"
  }
}));
